import React from 'react';
import { formatDate } from '../../utils/format';
import { marriageBanns, marriageCertificates, marriageList } from '../../api/endpoints';
import { Badge } from '../../components/ui';
import MergedRegisterScreen from './MergedRegisterScreen';
import type { MergedRegisterConfig } from './MergedRegisterScreen';
import { bannsConfig } from './MarriageBanns';
import { certificateConfig } from './MarriageCertificateRegister';
import MarriageSummary from './MarriageSummary';

const bannTone = (s?: string) =>
  s === 'Approved' ? 'success' : (s === 'Objected' || s === 'Cancelled') ? 'error' : 'neutral';

const marriageConfig: MergedRegisterConfig = {
  icon: '💍',
  title: 'Marriage Register',
  pageApi: marriageList.page,
  countsApi: marriageList.counts,
  searchPlaceholder: 'Search by record, groom, bride or minister…',
  summary: MarriageSummary,
  columns: [
    { key: 'date', header: 'Date', nowrap: true, render: (r: any) => formatDate(r.date) },
    { key: 'groom', header: 'Groom', render: (r: any) => r.groom || '-' },
    { key: 'bride', header: 'Bride', render: (r: any) => r.bride || '-' },
    {
      key: 'statusLabel', header: 'Status',
      render: (r: any) => (r.statusLabel ? <Badge tone={bannTone(r.statusLabel)}>{r.statusLabel}</Badge> : '—')
    }
  ],
  types: [
    {
      key: 'BANN', tabLabel: '📜 Banns', shortLabel: 'Banns', tone: 'accent',
      countKey: 'bann', recordLabel: 'Banns entry', resource: marriageBanns,
      emptyForm: bannsConfig.emptyForm, toForm: bannsConfig.toForm,
      validate: bannsConfig.validate, warn: bannsConfig.warn,
      fields: bannsConfig.fields, renderDocument: bannsConfig.renderDocument,
      // Passed straight through: the certificate, the register
      // listing, and the mapping onto the template's placeholders.
      printModule: bannsConfig.printModule, printDocumentType: bannsConfig.printDocumentType,
      listDocumentType: bannsConfig.listDocumentType, printData: bannsConfig.printData
    },
    {
      key: 'CERTIFICATE', tabLabel: '💍 Certificates', shortLabel: 'Certificate', tone: 'success',
      countKey: 'certificate', recordLabel: 'Marriage entry', resource: marriageCertificates,
      emptyForm: certificateConfig.emptyForm, toForm: certificateConfig.toForm,
      validate: certificateConfig.validate, warn: certificateConfig.warn,
      fields: certificateConfig.fields, renderDocument: certificateConfig.renderDocument,
      // Passed straight through: the certificate, the register
      // listing, and the mapping onto the template's placeholders.
      printModule: certificateConfig.printModule, printDocumentType: certificateConfig.printDocumentType,
      listDocumentType: certificateConfig.listDocumentType, printData: certificateConfig.printData
    }
  ]
};

const MarriageRegister = ({ isDarkMode }) => <MergedRegisterScreen config={marriageConfig} isDarkMode={isDarkMode} />;

export default MarriageRegister;
